import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MenuService } from '../../../services/menu.service';
import { PublicationService } from '../../../services/publication.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { LocationService } from '../../../services/location.service';
import { Publication } from 'app/interfaces/publication';
import { ActivatedRoute, Router } from '@angular/router';
import { StatisticsService } from '../../../services/statistics.service';

declare let window: Window;

interface Window {
	switchStats: switchStats;
}

@Component({
	templateUrl: './statistics.component.html',
	styleUrls: ['./statistics.component.scss']
})

export class StatisticsComponent {

	minDate: string;
	mode: string;
	ovpType: string;
	statisticsIframeSrc: SafeResourceUrl;

	constructor(
		private menuService: MenuService,
		private publicationService: PublicationService,
		private locationService: LocationService,
		private domSanitizer: DomSanitizer,
		private route: ActivatedRoute,
		private router: Router,
		private statisticsService: StatisticsService,
		private localStorageService: LocalStorageService) {

		window.switchStats = (mode: string) => {
			if (this.route.snapshot.routeConfig.path.endsWith(':mediaclipId')) {
				this.statisticsService.data = {mediaclipId: this.route.snapshot.params.mediaclipId};
				this.statisticsIframeSrc = null;
				this.router.navigate(['/analytics/statistics']);
				return;
			}
			let url = this.locationService.server + '/vms/stats/ovp6.php?ovpType=' + encodeURI(this.ovpType);

			if (mode === 'outstream' || mode === 'ads') {
				this.localStorageService.set('ovp-analyticsStatisticsMode', mode);
				url += '&mode=' + mode;
			} else {
				this.localStorageService.set('ovp-analyticsStatisticsMode', 'outstream');
			}

			url += (this.minDate ? '&minDate=' + this.minDate : '' );
			if (this.statisticsService.data && this.statisticsService.data.mediaclipId) {
				url += '#mediaclip/' + this.statisticsService.data.mediaclipId;
				this.statisticsService.data = {};
			}

			this.statisticsIframeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
		};

		this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.ovpType) {
				this.ovpType = publication.ovpType;
			}

			if (this.ovpType?.includes('advertising services')) {
				this.mode = 'outstream';
			}
			if (typeof this.localStorageService.get('ovp-analyticsStatisticsMode') !== 'undefined') {
				this.mode = this.localStorageService.get('ovp-analyticsStatisticsMode');
			}

			if (this.locationService.getParam('minDate')) {
				this.minDate = this.locationService.getParam('minDate').values.join();
			}

			window.switchStats(this.mode);
		});
	}

	openMenu() {
		this.menuService.showMobileMenu();
	}
}
